/* eslint-disable indent */
import { useTranslation } from 'react-i18next';

import PropTypes from 'prop-types';
import { useMemo } from 'react';
import RichTextViewer from 'components/RichTextViewer';
import { TIMEZONE_VN } from 'constant';
import { is1593 } from 'utils/func';

export default function OwnerSection({ owner, generalInfoData }) {
  // #region Data
  const { t } = useTranslation();
  // #endregion Data
  const template = useMemo(
    () => generalInfoData?.template || parseInt(generalInfoData?.template, 10) || null,
    [generalInfoData]
  );
  return (
    <div className="flex text-lg mt-2 flex-column">
      <h4>{t('projectProposal.general.ownerSection.label')}</h4>
      <div className="flex ml-5 flex-column">
        <div className="flex flex-wrap">
          <div className="w-30rem mb-2">
            <span className="font-semibold">
              {t('projectProposal.general.ownerSection.owner.academicRank')}:{' '}
            </span>
            <span>{owner?.academicRank ? t(`academicRank.${owner?.academicRank}`) : ''}</span>
          </div>
          <div className="mb-2">
            <span className="font-semibold">
              {t('projectProposal.general.ownerSection.owner.academicDegree')}:{' '}
            </span>
            <span>{owner?.academicDegree ? t(`academicDegree.${owner?.academicDegree}`) : ''}</span>
          </div>
        </div>
        <div className="mb-2">
          <span className="font-semibold">
            {t('projectProposal.general.ownerSection.owner.name')}:{' '}
          </span>
          <span>{owner?.fullname ?? generalInfoData?.owner?.fullname}</span>
        </div>
        <div className="mb-2">
          <span className="font-semibold">
            {t('projectProposal.general.ownerSection.owner.dob')}:{' '}
          </span>
          <span>
            {owner?.dob
              ? new Date(owner?.dob).toLocaleDateString('en-GB', { timeZone: TIMEZONE_VN })
              : null}
          </span>
        </div>
        <div className="flex flex-wrap">
          <div className="w-20rem mb-2">
            <span className="font-semibold">
              {t('projectProposal.general.ownerSection.owner.citizenId')}:{' '}
            </span>
            <span>{owner?.citizenId}</span>
          </div>
          <div className="w-15rem mb-2">
            <span className="font-semibold">
              {t('projectProposal.general.ownerSection.owner.dateOfIssue')}:{' '}
            </span>
            <span>
              {owner?.dateOfIssue
                ? new Date(owner?.dateOfIssue).toLocaleDateString('en-GB', {
                    timeZone: TIMEZONE_VN,
                  })
                : null}
            </span>
          </div>
          <div className="w-40rem mb-2">
            <span className="font-semibold">
              {t('projectProposal.general.ownerSection.owner.placeOfIssue')}:{' '}
            </span>
            <span>{owner?.placeOfIssue}</span>
          </div>
        </div>
        <div className="mb-2">
          <span className="font-semibold">
            {t('projectProposal.general.ownerSection.owner.taxIdentificationNumber')}:{' '}
          </span>
          <span>{owner?.taxIdentificationNumber}</span>
        </div>
        <div className="flex flex-wrap">
          <div className="w-30rem mb-2">
            <span className="font-semibold">
              {t('projectProposal.general.ownerSection.owner.bankAccount')}:{' '}
            </span>
            <span>{owner?.bankAccount ?? generalInfoData?.bankAccount}</span>
          </div>
          <div className="mb-2">
            <span className="font-semibold">
              {t('projectProposal.general.ownerSection.owner.bank')}:{' '}
            </span>
            <span>{owner?.bank ?? generalInfoData?.bank}</span>
          </div>
        </div>
        <div className="flex flex-wrap">
          <div className="mb-2">
            <span className="font-semibold">
              {t('projectProposal.general.ownerSection.owner.workplace')}:{' '}
            </span>
            <span>{generalInfoData?.workplace}</span>
          </div>
        </div>
        <div className="flex flex-wrap">
          <div className="w-30rem mb-2">
            <span className="font-semibold">
              {t('projectProposal.general.ownerSection.owner.mobile')}:{' '}
            </span>
            <span>{owner?.mobile ?? generalInfoData?.mobile}</span>
          </div>
          <div className="mb-2">
            <span className="font-semibold">Email: </span>
            <span>{owner?.email ?? generalInfoData?.email}</span>
          </div>
        </div>
        {!is1593(template) && (
          <div className="mb-2">
            <div className="mb-2">
              <span className="font-semibold">
                {t('projectProposal.general.ownerSection.owner.summarizedExperience')}:{' '}
              </span>
            </div>
            <RichTextViewer
              style={{ minHeight: '200px', width: '100%' }}
              value={owner?.experience ?? generalInfoData?.experience}
              showHeader={false}
              readOnly
            />
          </div>
        )}
      </div>
    </div>
  );
}

OwnerSection.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  owner: PropTypes.object.isRequired,
  // eslint-disable-next-line react/forbid-prop-types
  generalInfoData: PropTypes.object.isRequired,
};
